/**
 * Levels for logging messages.
 */
export enum LogLevels {
    info = 'info',
    warn = 'warn',
    log = 'log',
    error = 'error'
}
